import { Button } from "@/components/Button"
import { ContentLoading } from "@/components/content-loading"
import { Checkbox } from "@/components/Form/Checkbox"
import { PageTitle } from "@/components/Layout/PageTitle"
import { TablePagination } from "@/components/Pagination/TablePagination"
import { ITableHead, Table } from "@/components/Table"
import { cn, moneyFormat } from "@/utils"
import { maskCardNumber, TopUpContext, useCardList, useTopUpStore } from "@usher/pe-client-front-end-lib"
import { useContext, useMemo, useState } from "react"
import { FormattedMessage } from "react-intl"
import { Link, useHistory, useRouteMatch } from "react-router-dom"
const TABLE_HEADS: ITableHead[] = [
  {
    key: "card_number",
    label_id: "card-number",
  },
  {
    key: "name",
    label_id: "name-card",
  },
  {
    key: "nickname",
    label_id: "card-nickname",
  },
  {
    key: "expr",
    label_id: "expr-date",
  },
  {
    key: "type",
    label_id: "card-type",
  },
  {
    key: "status",
    label_id: "status",
  },
  {
    key: "balance",
    label_id: "balance",
  },
  {
    key: "actions",
    label_id: "card-actions",
    style: { width: "150px" },
  },
]
export const CardsList = () => {
  const history = useHistory()
  const [showLockedCards, setShowLockedCards] = useState(false)
  const { path } = useRouteMatch()
  const { cards, totalRecords, loading, setFilter, filter } = useCardList(10)
  const isWaitExist = cards.some((card) => card.status.toLowerCase().includes("wait"))
  const setCardType = useTopUpStore((state) => state.setCardType)
  const setCard = useContext(TopUpContext).setCard
  const showCreateCard = !loading && !isWaitExist
  const tableData = useMemo(() => {
    return cards
      .filter((card) => {
        return (showLockedCards || card.status.toLowerCase() !== "locked") && !card.status.toLowerCase().startsWith("not")
      })
      .map((card) => {
        const isLocked = card.status.toLowerCase() === "locked"
        return {
          id: card.id,
          card_number: <Link to={`${path}/${card.id}`}>{card.card_pan.length > 0 ? maskCardNumber(card.card_pan) : "********"}</Link>,
          name: card.card_holder || "N/A",
          nickname: card.card_name || "N/A",
          type: <div>{card.card_type === "1" ? "Virtual Card" : card.card_type === "2" ? "Physical Card" : "Own Card"}</div>,
          expr: card.expiry,
          status: (
            <div
              className={cn(
                "table-orders_cards-filter_status !text-[14px]",
                { locked: "!text-red-600", active: "!text-green-600" }[card.status.toLowerCase()],
              )}
            >
              {card.status}
            </div>
          ),
          balance: (
            <span
              className={cn({
                "text-red-600": Number(card.balance) < 0,
                "text-green-600": Number(card.balance) > 0,
              })}
            >
              {moneyFormat(Number(card.balance))} {card.currency ?? ""}
            </span>
          ),
          actions: (
            <div style={{ display: "flex", gap: "12px" }}>
              {!isLocked && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation()
                    const cardTypes = ["Virtual", "Physical", "Own Card"]
                    setCard(card)
                    setCardType(cardTypes[Number(card.card_type) - 1])
                    history.push("/topup/by-crypto")
                  }}
                >
                  {card.card_type === "3" ? "Payout To Card" : "Top-Up Card"}
                </Button>
              )}
              <Button
                onClick={(e) => {
                  e.stopPropagation()
                  history.push(`${path}/${card.id}`)
                }}
              >
                Details
              </Button>
            </div>
          ),
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards, path, history, showLockedCards])
  return (
    <>
      <PageTitle title_id="cards">
        {showCreateCard && (
          <Button to={`${path}/create`}>
            <FormattedMessage id="create-card-btn" />
          </Button>
        )}
      </PageTitle>
      <ContentLoading loading={loading}>
        <div className="table-orders mb-6" style={{ overflow: "visible" }}>
          <div className="table-orders_header">
            <div className="table-orders_title">
              <strong>
                <FormattedMessage id="total-cards" />
              </strong>{" "}
              {totalRecords}
            </div>
            <Checkbox label="Show blocked cards" checked={showLockedCards} onChange={() => setShowLockedCards(!showLockedCards)} />
          </div>
          <Table
            className="mb-7"
            classNames={{ header: "child:pb-3 child:px-4", row: "child:py-[22px]  text-cl14 text-black" }}
            onRowClick={(row) => {
              history.push(`${path}/${row.id}`)
            }}
            heads={TABLE_HEADS}
            data={tableData}
          />
        </div>
      </ContentLoading>
      {tableData.length > 0 && (
        <TablePagination
          perPage={filter.count}
          dataTotal={totalRecords}
          currentPage={filter.offset ?? 0}
          totalPages={Math.ceil(totalRecords / (filter.count ?? 10))}
          onPageChange={(page) => {
            setFilter(filter.count ?? 10, page)
          }}
        />
      )}
    </>
  )
}
